import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Groups from './groups';

export default function GroupsModule() {
  return (
    <Routes>
      <Route path="/" element={<Groups />} />
    </Routes>
  );
}